export default __webpack_public_path__ + "static/media/zoom-out-filled.e0c5e315.svg";